module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-2.4396669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-2.png
// module id = rRN/
// module chunks = 18